import { Platform, StyleSheet, TextStyle, useWindowDimensions, ViewStyle } from 'react-native';
import { Border, Breakpoints, Color, FontFamily, FontSize, Padding } from '@/GlobalStyles';
import { ImageStyle } from 'expo-image';

type UseFormStyleType = {
  headerForm?: TextStyle;
  bodyForm?: ViewStyle;
  input2Col?: ViewStyle;
  oeilContainer?: ViewStyle;
  rowForm?: ViewStyle;
  rowFormPadding?: ViewStyle;
  input1Col?: ViewStyle;
  input1ColWithoutPadding?: ViewStyle;
  groupForm?: ViewStyle;
  colGroupForm?: ViewStyle;
  footerForm?: ViewStyle;
  dividerSection?: ViewStyle;
  backgroundSection?: ViewStyle;
  titleGroupFormContainer?: ViewStyle;
  titleGroupForm?: TextStyle;
  titleGroupFormBase?: TextStyle;
  titleSubGroupForm?: TextStyle;
  titleSubGroupCol?: TextStyle;
  topImage?: ImageStyle;
};

const useFormStyle = () => {
  const { width } = useWindowDimensions();

  return StyleSheet.flatten<UseFormStyleType>([
    styles,
    width < Breakpoints.tablet ? mobileStyles : emptyStyles,
    Platform.OS === 'web' ? webStyles : emptyStyles,
  ]);
};

export default useFormStyle;

const styles = StyleSheet.create<UseFormStyleType>({
  headerForm: {
    fontFamily: FontFamily.labelBold,
    fontSize: FontSize.h3_size,
    color: Color.MainBleu,
    // textAlign: 'center',
    marginBottom: 40,
  },
  bodyForm: {
    flexDirection: 'column',
    rowGap: 25,
    marginTop: -25,
  },
  input2Col: {
    flexBasis: '50%',
    paddingHorizontal: 7,
  },
  input1Col: {
    flexBasis: '100%',
    paddingHorizontal: 7,
  },
  input1ColWithoutPadding: {
    flexBasis: '100%',
  },
  rowForm: {
    flexDirection: 'row',
    flexBasis: '100%',
    flexWrap: 'wrap',
    rowGap: 20,
  },
  oeilContainer: {
    borderRadius: Border.br_xs,
    padding: 7,
    flex: 1,
  },
  rowFormPadding: {
    flexDirection: 'row',
    flexBasis: '100%',
    flexWrap: 'wrap',
    columnGap: 20,
    rowGap: 20,
    paddingHorizontal: 7,
  },
  groupForm: {
    rowGap: 20,
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginHorizontal: -7,
  },
  colGroupForm: {
    rowGap: 20,
    flexDirection: 'column',
  },
  footerForm: {
    marginTop: 50,
    alignSelf: 'flex-end',
    zIndex: 3,
  },
  titleGroupForm: {
    fontSize: FontSize.h4_size,
    fontFamily: FontFamily.labelMedium,
    color: Color.MainNoir,
    flexBasis: '100%',
    paddingHorizontal: 7,
    marginTop: 25,
  },
  titleGroupFormContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    flexBasis: '100%',
    justifyContent: 'flex-start',
    gap: 20,
    paddingHorizontal: 7,
    paddingTop: 25,
  },
  titleGroupFormBase: {
    fontSize: FontSize.h4_size,
    fontFamily: FontFamily.labelMedium,
    color: Color.MainNoir,
  },
  titleSubGroupForm: {
    fontSize: FontSize.h5_size,
    fontFamily: FontFamily.labelBold,
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: '100%',
    paddingHorizontal: 7,
    color: Color.MainBleu,
  },
  titleSubGroupCol: {
    fontSize: FontSize.h5_size,
    fontFamily: FontFamily.labelBold,
    color: Color.MainBleu,
  },
  topImage: {
    position: 'absolute',
    top: 15,
    right: 15,
    width: 154,
    height: 154,
  },

  backgroundSection: {
    position: 'absolute',
    left: -Padding.p_13xl,
    right: -Padding.p_13xl,
    top: 0,
    bottom: 0,
    opacity: 0.03,
  },
  dividerSection: {
    height: 1,
    position: 'absolute',
    left: -Padding.p_13xl,
    right: -Padding.p_13xl,
    top: 0,
    backgroundColor: Color.colorGray_100,
  },
});

const mobileStyles = StyleSheet.create<UseFormStyleType>({
  input2Col: {
    flexBasis: '100%',
    paddingHorizontal: 7,
  },
  titleSubGroupForm: {
    fontSize: FontSize.h5_size,
    fontFamily: FontFamily.labelBold,
    paddingHorizontal: 7,
    color: Color.MainBleu,
  },
});

const emptyStyles = StyleSheet.create<UseFormStyleType>({});

const webStyles = StyleSheet.create<UseFormStyleType>({
  groupForm: {
    rowGap: 20,
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginHorizontal: -7,
    // @ts-ignore
    zIndex: 'auto',
  },
});
